// extracted by mini-css-extract-plugin
export default {"memberships":"MembershipPage_memberships__4zl7z","back":"MembershipPage_back__OFMnX"};